import { Component, OnInit, Input, ViewChild } from '@angular/core';
import {DialogRef, DialogService} from '@progress/kendo-angular-dialog';
import { FormGroup, FormBuilder, AbstractControl } from '@angular/forms';
import { FormService } from '../../../fw/services/form.service';
import { ValidationMessageComponent } from '../../shared/validation-message.component';
import { SharedValidators } from '../../shared/shared-validators';
import { Observable } from 'rxjs/Rx';
import { AutoUnsubscribe } from '../../../fw/decoractors/AutoUnsubscribe';
import {SharedService} from "../../shared/shared.service";
import {SettingsCashregService} from "./settings-cashreg.service";
import {ColumnDefinition} from "../../../fw/dynamic-grids/column-definition";
import {DynamicGridComponent} from "../../../fw/dynamic-grids/dynamic-grid.component";
import {AsyncValidatorWrapper} from "../../../fw/helpers/async-validator-wrapper";
import {DtoSubscriptionType} from "./models/DtoSubscriptionType";
import {DtoSubscriptionTypeBaseItems} from "./models/DtoSubscriptionTypeBaseItems";
import {PageSubheaderBarConfig} from "../../../fw/pages/page-config-api";
import {SubscriptionTypeTreatmentComponent} from "./subscription-type-treatment.component";
import {DtoTreatmentList} from "./models/DtoTreatmentList";
import {DtoSubscriptionTypeUseTreatment} from "./models/DtoSubscriptionTypeUseTreatment";

@Component({
    selector: 'ngx-subscription-type',
    template: require('./subscription-type.component.html'),
    styles: [require('./subscription-type.component.css')]
})
@AutoUnsubscribe()

export class SubscriptionTypeComponent implements OnInit {
    @Input() dialog: DialogRef;
    @Input() id: number;
    @Input() copyFromId: number;
    @ViewChild('validationMessage', {static: false}) validationMessage: ValidationMessageComponent;
    @ViewChild('gridPriceMutation', {static: false}) gridPriceMutation: DynamicGridComponent;
    @ViewChild('gridUseTreatment', {static: false}) gridUseTreatment: DynamicGridComponent;
    form: FormGroup;
    dtoObject: DtoSubscriptionType;
    baseItems: DtoSubscriptionTypeBaseItems;
    treatments: DtoTreatmentList[];
    activeItems: Array<{ text: string, value: boolean }> = [
        { text: "Ja", value: true },
        { text: "Nee", value: false }
    ];
    priceMutationColumnDefinition: ColumnDefinition[] = [
        {
            key: 'mutationDate',
            label: 'Ingangsdatum',
            type: 'date',
            width: '150px',
            format: '{0:dd-MM-yyyy}'
        },
        {
            key: 'btwGroupDesc',
            label: 'BTW %',
            type: 'string',
            width: '*'
        },
        {
            key: 'retailPrice',
            label: 'Prijs',
            type: 'number',
            width: '*',
            format: '{0:c}'
        },
        {
            key: 'discountPercentage',
            label: 'Korting %',
            type: 'number',
            width: '*'
        },
        {
            key: 'maxAmount',
            label: 'Maximum aantal',
            type: 'number',
            width: '*'
        },
        {
            key: 'noMaxAmount',
            label: 'Geen maximum',
            type: 'boolean',
            width: '*'
        }
    ];
    useTreatmentColumnDefinition: ColumnDefinition[] = [
        {
            key: 'index',
            label: 'Nummer',
            type: 'number',
            width: '150px'
        },
        {
            key: 'description',
            label: 'Omschrijving',
            type: 'string',
            width: '*'
        }
    ];
    useTreatmentConfig: PageSubheaderBarConfig = {
        title: 'BEHANDELINGEN',
        buttonDefinition: [
            {
                description: 'TOEVOEGEN',
                isSmall: true,
                clickEventType: 'create'
            },
            {
                description: 'VERWIJDEREN',
                isSmall: true,
                clickEventType: 'delete'
            }
        ]
    };
    endDateDisabled: boolean;
    maxAmountDisabled: boolean;

    constructor(private fb: FormBuilder,
                private fs: FormService,
                private ds: SettingsCashregService,
                private ss: SharedService,
                private dialogService: DialogService) {
    }

    ngOnInit() {
        this.form = this.fb.group({
            description: ['', [SharedValidators.customRequired], [AsyncValidatorWrapper.debounce(this.validateDescription.bind(this))]],
            index: [null,[SharedValidators.customRequired], [AsyncValidatorWrapper.debounce(this.validateIndex.bind(this))]],
            startDate: null,
            departmentId: [null, [SharedValidators.customRequired]],
            endDate: [null, [this.validateEndDate.bind(this)]],
            isEndless: null,
            retailPrice: null,
            isActive: null,
            btwGroupId: [null, [SharedValidators.customRequired]],
            maxAmount: [null, [this.validateMaxAmount.bind(this)]],
            noMaxAmount: null,
            customerImageMandatory: null,
            discountPercentage: null,
            employeeId: null,
            monday: null,
            tuesday: null,
            wednesday: null,
            thursday: null,
            friday: null,
            saturday: null,
            sunday: null
        });

        this.form.valueChanges.subscribe(() =>
            {if (this.validationMessage) this.validationMessage.getFormValidationErrors();}
        );
        this.form.get('isEndless').valueChanges.subscribe(newVal => {
            if (newVal === true) {
                this.endDateDisabled = true;
                this.form.patchValue({ ['endDate']: (null) });
            } else {
                this.endDateDisabled = false;
            }
        });
        this.form.get('noMaxAmount').valueChanges.subscribe(newVal => {
            if (newVal === true) {
                this.maxAmountDisabled = true;
                this.form.patchValue({ ['maxAmount']: (null) });
            } else {
                this.maxAmountDisabled = false;
            }
        });

        if (this.id > 0) {
            this.ds.getSubscriptionTypeById(this.id)
                .subscribe(response => {
                    this.dtoObject = response;
                    this.getBaseItems();
                    this.fs.patchDtoToForm(this.dtoObject, this.form);
                    this.gridPriceMutation.showData(this.dtoObject.subscriptionTypeMutations);
                    this.gridUseTreatment.showData(this.dtoObject.subscriptionTypeUseTreatments);
                });
        }
        else {
            this.ds.getSubscriptionTypeNextIndex()
                .subscribe(res => {
                    this.dtoObject = {
                        id: 0,
                        index: res,
                        isActive: true,
                        retailPrice: 0,
                        subscriptionTypeMutations: [],
                        subscriptionTypeUseTreatments: [],
                        startDate: this.ss.getCurrentDate(),
                        isEndless: true,
                        noMaxAmount: true,
                        customerImageMandatory: false,
                        discountPercentage: 0,
                        monday: false,
                        tuesday: false,
                        wednesday: false,
                        thursday: false,
                        friday: false,
                        saturday: false,
                        sunday: false
                    };
                    this.getBaseItems();

                    if (this.copyFromId > 0) {
                        this.ds.getSubscriptionTypeById(this.copyFromId)
                            .subscribe(response => {
                                this.dtoObject.endDate = response.endDate;
                                this.dtoObject.isEndless = response.isEndless;
                                this.dtoObject.retailPrice = response.retailPrice;
                                this.dtoObject.startDate = response.startDate;
                                this.dtoObject.maxAmount = response.maxAmount;
                                this.dtoObject.noMaxAmount = response.noMaxAmount;
                                this.dtoObject.customerImageMandatory = response.customerImageMandatory;
                                this.dtoObject.btwGroupId = response.btwGroupId;
                                this.dtoObject.discountPercentage = response.discountPercentage;
                                this.dtoObject.employeeId = response.employeeId;
                                this.dtoObject.departmentId = response.departmentId;
                                this.dtoObject.monday = response.monday;
                                this.dtoObject.tuesday = response.tuesday;
                                this.dtoObject.wednesday = response.wednesday;
                                this.dtoObject.thursday = response.thursday;
                                this.dtoObject.friday = response.friday;
                                this.dtoObject.saturday = response.saturday;
                                this.dtoObject.sunday = response.sunday;

                                for(let i = 0; i < response.subscriptionTypeUseTreatments.length; i++) {
                                    this.dtoObject.subscriptionTypeUseTreatments.push({
                                        id: 0,
                                        description: response.subscriptionTypeUseTreatments[i].description,
                                        treatmentId: response.subscriptionTypeUseTreatments[i].treatmentId,
                                        index: response.subscriptionTypeUseTreatments[i].index
                                    });
                                }

                                this.fs.patchDtoToForm(this.dtoObject, this.form);
                                this.gridUseTreatment.showData(this.dtoObject.subscriptionTypeUseTreatments);
                            });
                    }
                    else {
                        this.fs.patchDtoToForm(this.dtoObject, this.form);
                    }
                });
        }
    }

    getBaseItems() {
        this.ds.getSubscriptionTypeBaseItems(false).subscribe(response => {
            this.baseItems = response;
            if (this.dtoObject && this.dtoObject.id == 0) {
                if (this.baseItems.departments.length == 1) {
                    this.dtoObject.departmentId = this.baseItems.departments[0].id;
                }
            }
        });

        this.ds.getSubscriptionTypeTreatmentsToUse(false).subscribe(response => {
            this.treatments = response;
        });
    }

    getActiveBtwGroups() {
        if (this.baseItems) {
            return this.baseItems.btwGroups.filter(x => x.isActive);
        }
        return null;
    }

    checkForPriceChange() {
        let hasPriceChange: boolean = false;
        if (this.dtoObject.subscriptionTypeMutations.length > 0) {
            let lastPrice = this.dtoObject.subscriptionTypeMutations[0];
            hasPriceChange = ((lastPrice.btwGroupId != this.form.get('btwGroupId').value)
                || (lastPrice.retailPrice != this.form.get('retailPrice').value)
                || (lastPrice.maxAmount != this.form.get('maxAmount').value)
                || (lastPrice.noMaxAmount != this.form.get('noMaxAmount').value)
                || (lastPrice.monday != this.form.get('monday').value)
                || (lastPrice.tuesday != this.form.get('tuesday').value)
                || (lastPrice.wednesday != this.form.get('wednesday').value)
                || (lastPrice.thursday != this.form.get('thursday').value)
                || (lastPrice.friday != this.form.get('friday').value)
                || (lastPrice.saturday != this.form.get('saturday').value)
                || (lastPrice.sunday != this.form.get('sunday').value));
        }

        if (this.dtoObject.subscriptionTypeMutations.length == 0 || hasPriceChange) {
            this.dtoObject.subscriptionTypeMutations.push({
                id: 0,
                retailPrice: this.form.get('retailPrice').value,
                btwGroupId: this.form.get('btwGroupId').value,
                mutationDate: new Date(Date.now()),
                discountPercentage: this.form.get('discountPercentage').value,
                friday: this.form.get('friday').value,
                maxAmount: this.form.get('maxAmount').value,
                monday: this.form.get('monday').value,
                noMaxAmount: this.form.get('noMaxAmount').value,
                saturday: this.form.get('saturday').value,
                sunday: this.form.get('sunday').value,
                thursday: this.form.get('thursday').value,
                tuesday: this.form.get('tuesday').value,
                wednesday: this.form.get('wednesday').value
            });
        }
    }

    validateIndex(control: AbstractControl) {
        return Observable.create(observer => {
            if (this.dtoObject != null && control.dirty && control.value != null) {
                this.ds.checkSubscriptionTypeIndexAvailable(this.dtoObject.id, control.value)
                    .subscribe((response: boolean) => {
                        observer.next(response ? null : { indexNotAvailable: true });
                        observer.complete();
                        if (this.validationMessage) this.validationMessage.getFormValidationErrors();
                    });
            }
            else {
                observer.next(null);
                observer.complete();
                if (this.validationMessage) this.validationMessage.getFormValidationErrors();
            }
        });
    }

    validateDescription(control: AbstractControl) {
        return Observable.create(observer => {
            if (this.dtoObject != null && control.dirty && control.value != null) {
                this.ds.checkSubscriptionTypeDescriptionAvailable(this.dtoObject.id, control.value)
                    .subscribe((response: boolean) => {
                        observer.next(response ? null : { descriptionNotAvailable: true });
                        observer.complete();
                        if (this.validationMessage) this.validationMessage.getFormValidationErrors();
                    });
            }
            else {
                observer.next(null);
                observer.complete();
                if (this.validationMessage) this.validationMessage.getFormValidationErrors();
            }
        });
    }

    validateMaxAmount(control: AbstractControl) {
        if (control.dirty && control.value == null) {
            if (this.form.get('noMaxAmount').value === false) {
                return {required: true};
            }
        }
        return null;
    }

    validateEndDate(control: AbstractControl) {
        if (control.dirty && control.value == null) {
            if (this.form.get('isEndless').value === false) {
                return {required: true};
            }
        }
        return null;
    }

    btnCancelClicked(event) {
        this.closeWindow(false);
    }

    btnSaveClicked(event) {
        this.validationMessage.validateForm();

        if (this.form.valid) {
            this.checkForPriceChange();
            let result = this.fs.patchFormToDto(this.dtoObject, this.form);
            this.ds.saveSubscriptionType(result)
                .subscribe(response => {
                    if (!response.hasError) {
                        this.closeWindow(true);
                    }
                    else {
                        this.ss.message(response.errorMessage);
                    }
                });
        }
    }

    btnUseTreatmentBarClicked(event) {
        if (event == 'create') {
            this.showUseTreatmentWindow();
        } else if (event == 'delete') {
            if (this.gridUseTreatment.getSelectedId()) {
                this.dtoObject.subscriptionTypeUseTreatments.splice(this.dtoObject.subscriptionTypeUseTreatments.findIndex(x => x.id == this.gridUseTreatment.getSelectedId()), 1);
                this.gridUseTreatment.showData(this.dtoObject.subscriptionTypeUseTreatments);
            }
        }
    }

    showUseTreatmentWindow() {
        if (this.treatments) {
            const dialogRef = this.dialogService.open({
                content: SubscriptionTypeTreatmentComponent
            });

            const dialogContent: SubscriptionTypeTreatmentComponent = dialogRef.content.instance;
            dialogContent.dialog = dialogRef;
            dialogContent.allTreatments = this.treatments;
            dialogContent.chosenTreatments = this.dtoObject.subscriptionTypeUseTreatments;
            dialogContent.treatmentSaved
                .subscribe((res: DtoSubscriptionTypeUseTreatment) => {
                    this.dtoObject.subscriptionTypeUseTreatments.push(res);
                    this.gridUseTreatment.showData(this.dtoObject.subscriptionTypeUseTreatments);
                });
        }
    }

    closeWindow(result: boolean) {
        if (this.dialog) {
            this.dialog.dialog.instance.action.emit(result);
            this.dialog.close();
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/app/settings/settings-cashreg/subscription-type.component.ts